import { render, staticRenderFns } from "./FilterListPending.vue?vue&type=template&id=2712cdb5&scoped=true"
import script from "./FilterListPending.vue?vue&type=script&lang=js"
export * from "./FilterListPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2712cdb5",
  null
  
)

export default component.exports